import ShowModulePercentage from '../ShowModulePercentage';

const ModuleCardStats = ({ showCompleteness, completenessPercent, showRisk, riskPercent }) => {
    return (
        <div className='df aic' style={{ gap: '0.25rem', flexWrap: 'wrap' }}>
            {showCompleteness && (
                <ShowModulePercentage value={completenessPercent} type="Module Complete" />
            )}
            {showRisk && (
                <ShowModulePercentage value={riskPercent} type="Module Risk" />
            )}
        </div>
    );
};

export default ModuleCardStats;
